import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PayPalPayment = () => {
  const [searchParams] = useSearchParams();
  const amount = searchParams.get('amount') || '0';
  const name = searchParams.get('name') || '';
  const orderNum = searchParams.get('order') || '';
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/payment-providers/config`);
        if (!mounted) return;
        const email = data.paypal_email;
        const business = data.business_name || 'בריאות הגבר';
        if (!email) {
          setError('PayPal אינו מוגדר כרגע');
          return;
        }
        const amt = parseFloat(amount).toFixed(2);
        const itemName = `${business} - הזמנה ${orderNum ? '#' + orderNum : ''}`.trim();
        const origin = window.location.origin;
        // PayPal classic xclick URL with pre-filled amount / business / item
        const url = `https://www.paypal.com/cgi-bin/webscr?` + [
          `cmd=_xclick`,
          `business=${encodeURIComponent(email)}`,
          `item_name=${encodeURIComponent(itemName)}`,
          `amount=${amt}`,
          `currency_code=ILS`,
          `no_shipping=1`,
          `return=${encodeURIComponent(origin + '/checkout?status=success')}`,
          `cancel_return=${encodeURIComponent(origin + '/checkout?status=failed')}`,
        ].join('&');
        window.location.href = url;
      } catch (_e) {
        if (mounted) setError('שגיאה בטעינת תשלום PayPal');
      }
    })();
    return () => { mounted = false; };
  }, [amount, orderNum, name]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4" dir="rtl">
        <div className="text-center">
          <p className="text-red-500 font-bold mb-2">{error}</p>
          <p className="text-stone-400 text-sm">נסו שוב מאוחר יותר</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center" dir="rtl">
      <div className="text-center" data-testid="paypal-redirect-loading">
        <div className="w-16 h-16 bg-[#003087] rounded-2xl mx-auto mb-4 flex items-center justify-center">
          <span className="text-white font-black text-xl" style={{ fontFamily: 'Arial, sans-serif' }}>PP</span>
        </div>
        <div className="w-8 h-8 border-3 border-[#003087] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-stone-500">מעביר לתשלום ב-PayPal...</p>
        <p className="text-center text-[11px] text-stone-500 mt-4 px-4 leading-relaxed max-w-xs mx-auto" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="terms-disclaimer-paypal">
          בלחיצה על המשך תשלום, קראתי והנני מאשר את{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-[#D97706] hover:underline font-bold">
            תנאי השימוש ותקנון האתר
          </a>
        </p>
      </div>
    </div>
  );
};

export default PayPalPayment;
